import { array, boolean, object, string } from 'yup';
import { nameENRegex, namHERegex } from '../helpers';

const ipRegex =
  /^(?:(?:25[0-5]|2[0-4]\d|1?\d?\d)(?:\.(?:25[0-5]|2[0-4]\d|1?\d?\d)){3}|(?:[0-9a-fA-F]{1,4}:){2,7}[0-9a-fA-F]{1,4}|\*)$/;

export const shippingCompanyManagementValidation = object().shape({
  nameHE: string().trim().required('שדה חובה'),
  nameEN: string().trim().required('שדה חובה'),
  allowedIps: array()
    .of(
      string()
        .trim()
        .required('שדה חובה')
        .matches(ipRegex, 'כתובת IP אינה תקינה')
    )
    .min(1, 'יש להזין כתובת IP אחת לפחות')
    .required('שדה חובה'),
  isActive: boolean().required('שדה חובה'),
});
